import { useContext, useMemo, useCallback } from 'react'
import GlobalsContext from 'sb-hooks/GlobalsContext'
import cookie from 'js-cookie'


const isSSR = process.env.WEBPACK === 'build.server'

const createSetCookieHandler = (_setCookie, _removeCookie) => (name: string, value: any, params = {}) => {
  if (typeof value === 'undefined' || value === null) {
    console.error(`Set cookie ${name} with "${value}" value !`)

    if (isSSR) {
      _removeCookie(name)
    }
    else {
      cookie.remove(name)
    }

    return
  }

  if (isSSR) {
    _setCookie(name, value, { expires: 365, ...params })
  }
  else {
    cookie.set(name, value, { expires: 365, ...params })
  }
}

const useCookies = () => {
  const { globals } = useContext(GlobalsContext)
  const {
    setCookie: setServerCookie,
    getCookie: getServerCookie,
    removeCookie: removeServerCookie,
  } = globals || {}

  const getCookie: <T extends any>(name: string) => T = useCallback((name: string) => (
    isSSR ? getServerCookie(name) : cookie.getJSON(name)
  ), [ getServerCookie ])

  const setCookie = useMemo(() => (
    createSetCookieHandler(setServerCookie, removeServerCookie)
  ), [ setServerCookie, removeServerCookie ])

  const removeCookie: (name: string) => void = useMemo(() => (
    isSSR ? removeServerCookie : cookie.remove
  ), [ removeServerCookie ])

  const setSessionCookie = useCallback((name: string, value: any, params = {}) => {
    setCookie(name, value, { ...params, maxAge: 0, expires: 0 })
  }, [ setCookie ])

  return useMemo(() => ({
    setCookie,
    getCookie,
    removeCookie,
    setSessionCookie,
  }), [ setCookie, getCookie, setSessionCookie, removeCookie ])
}


export default useCookies
